
  // --- Quantity + subscription pricing engine ---
  // Pack size (tube count) and delivery frequency are independent choices;
  // subscribing always takes 20% off whatever pack size is currently selected.
  var SUBSCRIBE_DISCOUNT = 0.8;
  (function(){
    var plansWrap = document.querySelector('.purchase-plans');
    if(plansWrap && plansWrap.dataset.subDiscount){ SUBSCRIBE_DISCOUNT = parseFloat(plansWrap.dataset.subDiscount) || 0.8; }
  })();
  function fmt(n){ return '$' + n.toFixed(2); }
  function currentQty(){
    var sel = document.querySelector('.qty-option.selected');
    if(!sel) return { count:3, unit:39.99, total:119.97, freqDefault:'3', variantId:'' };
    var count = parseInt(sel.dataset.qty,10);
    var unit = parseFloat(sel.dataset.unit);
    var total = sel.dataset.total ? parseFloat(sel.dataset.total) : unit * count;
    return { count: count, unit: unit, total: total, freqDefault: sel.dataset.freqDefault, variantId: sel.dataset.variantId || '' };
  }
  function activeFreqMonths(){
    var active = document.querySelector('.freq-pill.active');
    return active ? active.dataset.months : '3';
  }
  function isActivationKey(e){
    return e.key === 'Enter' || e.key === ' ';
  }
  function isMobileSticky(){
    return window.matchMedia('(max-width: 900px)').matches;
  }
  function syncPricing(){
    var q = currentQty();
    var oneTimeTotal = q.total;
    var subTotal = oneTimeTotal * SUBSCRIBE_DISCOUNT;
    var oneTimeEl = document.getElementById('oneTimePrice');
    var subOldEl = document.getElementById('subOldPrice');
    var subNowEl = document.getElementById('subNowPrice');
    var billedEl = document.getElementById('planBilled');
    if(oneTimeEl) oneTimeEl.textContent = fmt(oneTimeTotal);
    if(subOldEl) subOldEl.textContent = fmt(oneTimeTotal);
    if(subNowEl) subNowEl.textContent = fmt(subTotal);
    var m = activeFreqMonths();
    var lblPill = document.querySelector('.freq-pill.active');
    var freqLabel = (lblPill && lblPill.dataset.label) ? lblPill.dataset.label : (m==='1' ? 'every month' : 'every '+m+' months');
    freqLabel = freqLabel.replace(/^\s*every\s+every\s+/i,'every ').replace(/\*+$/,'').trim();
    if(billedEl) billedEl.textContent = 'Billed ' + fmt(subTotal) + ' ' + freqLabel;
    // Locked delivery cadence shown as a statement, not a choice (pills stay in the DOM, hidden, to carry the plan id)
    var freqLabelEl = document.querySelector('.freq-select-label');
    if(freqLabelEl) freqLabelEl.textContent = 'Delivered ' + freqLabel + (q.count > 1 ? ' (' + q.count + ' tubes per delivery)' : '');
    var qtyCompare = document.getElementById('qtyCompare');
    if(qtyCompare){
      var baseOpt = document.querySelector('.qty-option[data-qty="1"]');
      var baseUnit = baseOpt && baseOpt.dataset.total ? parseFloat(baseOpt.dataset.total) : 49.99;
      var packSaved = (baseUnit * q.count) - oneTimeTotal;
      qtyCompare.textContent = packSaved > 0.01 ? 'Save ' + fmt(packSaved) + ' vs buying tubes individually' : '';
    }
    var planSavings = document.getElementById('planSavings');
    if(planSavings){
      var orderSave = oneTimeTotal - subTotal;
      planSavings.textContent = 'Save ' + fmt(orderSave) + ' on this order';
    }
    var activePlan = document.querySelector('.purchase-plans [data-freq].selected');
    var isSubscribe = activePlan && activePlan.dataset.freq === 'subscribe';
    document.querySelectorAll('.qty-option').forEach(function(opt){
      opt.setAttribute('aria-pressed', opt.classList.contains('selected') ? 'true' : 'false');
    });
    document.querySelectorAll('.purchase-plans [data-freq]').forEach(function(plan){
      plan.setAttribute('aria-pressed', plan.classList.contains('selected') ? 'true' : 'false');
    });
    var otpEl = document.querySelector('#mainAtc .otp');
    var subPct = Math.round((1 - SUBSCRIBE_DISCOUNT) * 100);
    if(otpEl) otpEl.textContent = fmt(isSubscribe ? subTotal : oneTimeTotal);
    var atc = document.querySelector('#mainAtc .label');
    if(atc){
      atc.textContent = isSubscribe ? 'Subscribe' : 'Add To Cart';
    }
    // Keep the sticky bottom bar in sync (pack size, plan, price, picker options)
    var displayPrice = isSubscribe ? subTotal : oneTimeTotal;
    var stickyLabel = document.getElementById('stickySelLabel');
    var stickySelSub = document.getElementById('stickySelSub');
    var stickyBtn = document.getElementById('stickyAtcBtn');
    var packLabel = q.count + (q.count>1?' Tubes':' Tube');
    if(stickyLabel) stickyLabel.textContent = packLabel + ' · ' + (isSubscribe ? 'Subscribe & Save' : 'One-Time');
    if(stickySelSub) stickySelSub.textContent = fmt(q.unit) + ' each';
    if(stickyBtn){
      stickyBtn.textContent = isMobileSticky() ? 'ADD · ' + fmt(displayPrice) : 'Add To Cart — ' + fmt(displayPrice);
      stickyBtn.setAttribute('aria-label', 'Add to cart — ' + fmt(displayPrice));
    }
    // Update each picker option's price + selected state
    document.querySelectorAll('.sticky-opt').forEach(function(opt){
      var oc = document.querySelector('.qty-option[data-qty="'+opt.dataset.qty+'"]');
      if(oc){
        var total = oc.dataset.total ? parseFloat(oc.dataset.total) : parseFloat(oc.dataset.unit) * parseInt(oc.dataset.qty,10);
        var shown = isSubscribe ? total*SUBSCRIBE_DISCOUNT : total;
        var pe = opt.querySelector('.sticky-opt-price'); if(pe) pe.textContent = fmt(shown);
      }
      opt.classList.toggle('selected', opt.dataset.qty === String(q.count));
    });
    var vidInput = document.getElementById('nanoxVariantId');
    if(vidInput && q.variantId) vidInput.value = q.variantId;
    var buyForm = document.getElementById('nanoxBuyForm');
    var spInput = document.getElementById('nanoxSellingPlan') || (buyForm && buyForm.querySelector('input[name="selling_plan"]'));
    if(!spInput && buyForm && document.querySelector('.freq-pill[data-plan-id]')){
      // Seal's widget script can strip the hidden input; recreate it so subscribe never silently posts one-time
      spInput = document.createElement('input');
      spInput.type = 'hidden';
      spInput.name = 'selling_plan';
      spInput.id = 'nanoxSellingPlan';
      buyForm.appendChild(spInput);
    }
    if(spInput){
      // Never post a subscribe selection without a plan id. If no pill is active
      // (e.g. the store's plans don't match a tile's data-freq-default), fall back
      // to the first real plan rather than silently posting a full-price one-time order.
      var activePill = document.querySelector('.freq-pill.active');
      if(isSubscribe && (!activePill || !activePill.dataset.planId)){
        activePill = document.querySelector('.freq-pill[data-plan-id]');
        if(activePill) setActivePill(activePill);
      }
      if(isSubscribe && activePill && activePill.dataset.planId){
        spInput.value = activePill.dataset.planId;
        spInput.disabled = false;
      } else {
        spInput.value = '';
        spInput.disabled = true;
      }
    }
  }
  function setActivePill(pill){
    document.querySelectorAll('.freq-pill').forEach(p=>p.classList.toggle('active', p===pill));
  }
  function setFrequency(months){
    var pills = document.querySelectorAll('.freq-pill');
    if(!pills.length) return;
    var match = null;
    pills.forEach(function(p){ if(p.dataset.months===String(months)) match = p; });
    // No plan matches this tile's default — use the first available plan instead of
    // leaving every pill inactive, which would strip the selling_plan from the form.
    if(!match) match = document.querySelector('.freq-pill[data-plan-id]') || pills[0];
    setActivePill(match);
  }
  document.querySelectorAll('.qty-option').forEach(el=>{
    el.addEventListener('click',()=>{
      document.querySelectorAll('.qty-option').forEach(o=>o.classList.remove('selected'));
      el.classList.add('selected');
      // Delivery frequency is locked to the pack size: 1 tube monthly, 2 tubes every 2 months, 3 tubes every 3 months.
      setFrequency(el.dataset.freqDefault);
      syncPricing();
    });
    el.addEventListener('keydown', function(e){
      if(!isActivationKey(e)) return;
      e.preventDefault();
      el.click();
    });
  });
  document.querySelectorAll('.purchase-plans [data-freq]').forEach(el=>{
    el.addEventListener('click',()=>{
      document.querySelectorAll('.purchase-plans [data-freq]').forEach(o=>o.classList.remove('selected'));
      el.classList.add('selected');
      syncPricing();
    });
    el.addEventListener('keydown', function(e){
      if(!isActivationKey(e)) return;
      e.preventDefault();
      el.click();
    });
  });
  document.querySelectorAll('.freq-pill').forEach(pill=>{
    pill.addEventListener('click', function(e){
      e.stopPropagation();
      setFrequency(pill.dataset.months);
      syncPricing();
    });
  });
  var reveal = document.querySelector('.plan-reveal');
  if(reveal){ reveal.addEventListener('click', function(e){ e.stopPropagation(); }); }
  (function(){
    var grid = document.getElementById('reviewGrid');
    var btn = document.getElementById('reviewsMoreBtn');
    if(!grid || !btn) return;
    var extraCount = grid.querySelectorAll('.review-card.is-extra').length;
    var label = btn.querySelector('.reviews-more-label');
    function setLabel(expanded){
      if(label) label.textContent = expanded ? 'Show less' : 'See ' + extraCount + ' more review' + (extraCount === 1 ? '' : 's');
    }
    btn.addEventListener('click', function(){
      var expanded = grid.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      setLabel(expanded);
    });
  })();
  // --- Sticky CTA pack picker (IM8-style dropdown) ---
  (function(){
    var sel = document.getElementById('stickySelect');
    var pop = document.getElementById('stickyPopover');
    if(!sel || !pop) return;
    function openPop(){ pop.classList.add('open'); sel.setAttribute('aria-expanded','true'); }
    function closePop(){ pop.classList.remove('open'); sel.setAttribute('aria-expanded','false'); }
    sel.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); pop.classList.contains('open') ? closePop() : openPop(); });
    pop.querySelectorAll('.sticky-opt').forEach(function(opt){
      opt.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        // Drive the main quantity selector so everything stays in sync
        var target = document.querySelector('.qty-option[data-qty="'+opt.dataset.qty+'"]');
        if(target) target.click();
        closePop();
      });
    });
    document.addEventListener('click', function(e){ if(pop.classList.contains('open') && !e.target.closest('#stickyAtc')) closePop(); });
  })();

  // Sync the sticky bar's product name from the main title (single source of truth)
  (function(){
    var stickyName = document.getElementById('stickyName');
    var titleEl = document.querySelector('.product-title');
    if(stickyName && titleEl) stickyName.textContent = titleEl.textContent.trim();
  })();

  // Initialize on load — match delivery frequency to the pre-selected pack
  (function(){
    document.querySelectorAll('.freq-pill').forEach(function(p){
      var m = String(p.dataset.months || '').replace(/\D/g, '');
      p.dataset.months = m || '1';
    });
    // Frequency follows the preselected pack (1 tube = every month)
    var selTile = document.querySelector('.qty-option.selected');
    setFrequency(selTile && selTile.dataset.freqDefault ? selTile.dataset.freqDefault : '1');
  })();
  syncPricing();
  window.addEventListener('resize', syncPricing);

  // (delivery countdown removed)

  // --- Image lightbox (click-to-zoom, blurred backdrop) ---
  (function(){
    var lb = document.getElementById('lightbox');
    var lbImg = document.getElementById('lightboxImg');
    var main = document.getElementById('galleryMain');
    var galleryBg = document.querySelector('.gallery-bg');
    if(!lb || !lbImg || !main) return;
    function open(){ lbImg.src = main.src; lb.classList.add('open'); lb.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function close(){ lb.classList.remove('open'); lb.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    var zoomBtn = document.querySelector('.gallery-zoom');
    if(zoomBtn) zoomBtn.addEventListener('click', function(e){ e.stopPropagation(); open(); });
    lb.querySelector('.lightbox-close').addEventListener('click', close);
    lb.addEventListener('click', function(e){ if(e.target === lb) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && lb.classList.contains('open')) close(); });
  })();

  // --- Ingredients modal (gallery "View Ingredients" + section CTA) ---
  (function(){
    var modal = document.getElementById('ingModal');
    if(!modal) return;
    var closeBtn = modal.querySelector('.ing-modal-close');
    function open(e){ if(e) e.preventDefault(); modal.classList.add('open'); modal.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
    function close(){ modal.classList.remove('open'); modal.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    ['openIngModal','openIngModalFoot'].forEach(function(id){
      var el = document.getElementById(id);
      if(el) el.addEventListener('click', open);
    });
    if(closeBtn) closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if(e.target === modal) close(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('open')) close(); });
  })();

  (function(){
    const thumbs = Array.from(document.querySelectorAll('.thumbs > div'));
    const main = document.getElementById('galleryMain');
    const galleryBg = document.getElementById('galleryBg');
    const prevBtn = document.getElementById('galleryPrev');
    const nextBtn = document.getElementById('galleryNext');
    const dots = document.querySelectorAll('.gallery-pagination span');
    const bestSellerBadge = document.getElementById('galleryBestSeller');
    if(!thumbs.length || !main || !galleryBg) return;
    const slideBackgrounds = ['#fff', '#fff', '#fff', '#fff'];
    let index = 0;
    let startX = 0;
    let dragging = false;

    window.setGalleryIndex = function(i){
      index = (i + thumbs.length) % thumbs.length;
      thumbs.forEach((t, n)=>{
        const selected = n === index;
        t.classList.toggle('selected', selected);
        t.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      const full = thumbs[index].dataset.full;
      if(full) main.src = full;
      galleryBg.style.background = slideBackgrounds[index] || 'var(--gallery-bg)';
      dots.forEach((d, n)=>d.classList.toggle('active', n === index));
      if(bestSellerBadge){
        const show = index === 0;
        bestSellerBadge.classList.toggle('is-visible', show);
        bestSellerBadge.setAttribute('aria-hidden', String(!show));
      }
      const sizeTag = document.querySelector('.gallery-size-tag');
      if(sizeTag){ sizeTag.style.display = index === 0 ? '' : 'none'; }
      main.style.setProperty('--drag-x','0px');
    };

    thumbs.forEach((el, idx)=>{
      el.addEventListener('click',()=>setGalleryIndex(idx));
      el.addEventListener('keydown', e=>{
        if(!isActivationKey(e)) return;
        e.preventDefault();
        setGalleryIndex(idx);
      });
    });

    function step(dir){ setGalleryIndex(index + dir); }

    if(prevBtn) prevBtn.addEventListener('click', e=>{ e.stopPropagation(); step(-1); });
    if(nextBtn) nextBtn.addEventListener('click', e=>{ e.stopPropagation(); step(1); });

    galleryBg.addEventListener('pointerdown', e=>{
      if(e.target.closest('.gallery-nav,.gallery-zoom')) return;
      dragging = true;
      startX = e.clientX;
      galleryBg.classList.add('is-dragging');
      galleryBg.setPointerCapture(e.pointerId);
    });
    galleryBg.addEventListener('pointermove', e=>{
      if(!dragging) return;
      const dx = e.clientX - startX;
      main.style.setProperty('--drag-x', (dx * 0.35) + 'px');
    });
    function endDrag(e){
      if(!dragging) return;
      dragging = false;
      galleryBg.classList.remove('is-dragging');
      const dx = e.clientX - startX;
      main.style.setProperty('--drag-x','0px');
      if(dx < -50) step(1);
      else if(dx > 50) step(-1);
    }
    galleryBg.addEventListener('pointerup', endDrag);
    galleryBg.addEventListener('pointercancel', endDrag);
  })();
  document.querySelectorAll('.accordion-row').forEach(row=>{
    const btn = row.querySelector('.accordion-item[aria-expanded]');
    const panel = row.querySelector('.accordion-panel');
    if(!btn || !panel) return;
    btn.addEventListener('click',()=>{
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  });

  (function(){
    const mainAtc = document.getElementById('mainAtc');
    const stickyAtc = document.getElementById('stickyAtc');
    const footer = document.querySelector('footer');
    if(!mainAtc || !stickyAtc || !footer) return;
    let mainVisible = true;
    let footerVisible = false;
    const sync = () => {
      const show = !mainVisible && !footerVisible;
      stickyAtc.classList.toggle('visible', show);
    };
    new IntersectionObserver(entries=>{
      const entry = entries[0];
      // Treat "hasn't been scrolled to yet" (still below viewport) the same as visible —
      // only count it as passed once it has scrolled above the viewport top.
      mainVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
      sync();
    }, {threshold:0}).observe(mainAtc);
    new IntersectionObserver(entries=>{
      footerVisible = entries[0].isIntersecting;
      sync();
    }, {threshold:0}).observe(footer);
    const stickyAddBtn = document.getElementById('stickyAtcBtn');
    if(stickyAddBtn) stickyAddBtn.addEventListener('click', ()=>{
      mainAtc.scrollIntoView({behavior:'smooth', block:'center'});
      setTimeout(function(){
        if(mainAtc.tagName === 'BUTTON') mainAtc.click();
      }, 350);
    });
  })();

  // --- Mobile floating mini-header: appears once the main nav scrolls out of view ---
  (function(){
    const mainNav = document.querySelector('.nav');
    const miniHeader = document.getElementById('miniHeader');
    if(!mainNav || !miniHeader) return;
    new IntersectionObserver(entries=>{
      const entry = entries[0];
      miniHeader.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {threshold:0}).observe(mainNav);
  })();

  function wireCarousel(trackSelector, cardSelector, navId, gap){
    const track = document.querySelector(trackSelector);
    const nav = document.getElementById(navId);
    if(!track || !nav) return;
    const dots = nav.querySelectorAll('.dots span');
    const cardCount = track.querySelectorAll(cardSelector).length;
    const cardWidth = () => {
      const card = track.querySelector(cardSelector);
      return card ? card.getBoundingClientRect().width + gap : 230;
    };
    const setActive = idx => dots.forEach((d,i)=>d.classList.toggle('active', i===idx));
    // Click handler computes the target index directly rather than relying solely on the
    // 'scroll' event firing afterward — instant scrollBy + scroll-snap doesn't reliably
    // fire 'scroll' in every browser/timing scenario, so this keeps dots in sync regardless.
    nav.querySelectorAll('.carousel-btns button').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const current = Math.round(track.scrollLeft / cardWidth());
        const next = Math.max(0, Math.min(cardCount - 1, current + Number(btn.dataset.dir)));
        track.scrollTo({left: next * cardWidth(), behavior:'auto'});
        setActive(next);
      });
    });
    track.addEventListener('scroll', ()=>{
      setActive(Math.round(track.scrollLeft / cardWidth()));
    }, {passive:true});
  }
  wireCarousel('.benefit-grid', '.benefit-card', 'benefitCarouselNav', 10);
  wireCarousel('.review-grid', '.review-card', 'reviewCarouselNav', 14);

  // --- Buy form: submit via AJAX so Shopify publishes product_added_to_cart
  // (Meta AddToCart via the Facebook & Instagram channel pixel). A plain form
  // POST to /cart/add skips that event. Same landing (/cart) as before; falls
  // back to the native submit if the request fails.
  (function(){
    var buyForm = document.getElementById('nanoxBuyForm');
    if(!buyForm || !window.fetch || !window.FormData) return;
    buyForm.addEventListener('submit', function(e){
      if(buyForm.dataset.nativeSubmit === '1') return;
      e.preventDefault();
      var btn = buyForm.querySelector('button[type="submit"], [type="submit"]');
      if(btn) btn.disabled = true;
      fetch('/cart/add.js', { method:'POST', body:new FormData(buyForm), headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' } })
        .then(function(r){ if(!r.ok) throw new Error('cart/add.js ' + r.status); return r.json(); })
        .then(function(){ window.location.href = '/cart'; })
        .catch(function(){
          if(btn) btn.disabled = false;
          buyForm.dataset.nativeSubmit = '1';
          buyForm.submit();
        });
    });
  })();

  // Footer signup is a demo capture on this static PDP; avoid a page reload.
  (function(){
    const form = document.getElementById('footerEmailForm');
    const msg = document.getElementById('footerEmailMsg');
    if(!form || !msg) return;
    form.addEventListener('submit', e=>{
      e.preventDefault();
      const input = form.querySelector('input[type="email"]');
      if(input && input.value.trim()){
        msg.textContent = 'Thanks — you are on the NanoXtreme email list.';
        input.value = '';
      }
    });
  })();

  const isMobileLayout = () => window.matchMedia('(max-width: 900px)').matches;
  document.querySelectorAll('.footer-col').forEach(col=>{
    const btn = col.querySelector('.footer-col-toggle');
    const panel = col.querySelector('.footer-col-panel');
    btn.addEventListener('click', ()=>{
      if(!isMobileLayout()) return; // desktop columns are always-open, not collapsible
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  });

  // --- "Complete the routine" upsell add buttons ---
  document.querySelectorAll('.routine-add').forEach(btn=>{
    const original = btn.innerHTML;
    btn.addEventListener('click', ()=>{
      if(btn.classList.contains('added')) return;
      btn.classList.add('added');
      btn.textContent = 'Added ✓';
      setTimeout(()=>{ btn.classList.remove('added'); btn.innerHTML = original; }, 1800);
    });
  });


;


(function(){
  var el=document.querySelector('[data-ship-date]');
  if(!el) return;
  var d=new Date(); d.setDate(d.getDate()+2);
  el.textContent=d.toLocaleDateString('en-US',{weekday:'short',day:'numeric',month:'short'});
})();


;


(function(){
  var hero=document.getElementById('v4hero');
  var purchase=document.getElementById('purchase');
  var bar=document.getElementById('v5Sticky');
  var btn=document.getElementById('v5StickyBtn');
  if(!hero||!purchase||!bar) return;
  var heroPassed=false, purchaseReached=false;
  function sync(){ bar.classList.toggle('visible', heroPassed && !purchaseReached); }
  new IntersectionObserver(function(e){
    var en=e[0];
    heroPassed = !en.isIntersecting && en.boundingClientRect.bottom < 0;
    sync();
  },{threshold:0}).observe(hero);
  new IntersectionObserver(function(e){
    var en=e[0];
    purchaseReached = en.isIntersecting || en.boundingClientRect.top < 0;
    sync();
  },{threshold:0}).observe(purchase);
  if(btn) btn.addEventListener('click',function(){
    purchase.scrollIntoView({behavior:'smooth',block:'start'});
  });
})();


;

(function(){
  var tl=document.querySelector('.v5-tl'); if(!tl) return;
  var steps=[].slice.call(tl.querySelectorAll('.v5-step'));
  function upd(){
    var r=tl.getBoundingClientRect(), vh=window.innerHeight;
    var p=(vh*0.75 - r.top)/r.height; p=Math.max(0,Math.min(1,p));
    tl.style.setProperty('--tl-progress',p);
    steps.forEach(function(s){ s.classList.toggle('tl-on', s.getBoundingClientRect().top < vh*0.75); });
  }
  window.addEventListener('scroll',upd,{passive:true});
  window.addEventListener('resize',upd);
  upd();
})();


;

(function(){
  var car=document.getElementById('revCar'); if(!car) return;
  var paused=false, down=false, sx=0, sl=0, moved=false;
  car.addEventListener('mouseenter',function(){paused=true;});
  car.addEventListener('mouseleave',function(){paused=false;down=false;car.classList.remove('dragging');});
  car.addEventListener('touchstart',function(){paused=true;},{passive:true});
  car.addEventListener('touchend',function(){setTimeout(function(){paused=false;},4000);},{passive:true});
  car.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=car.scrollLeft;car.classList.add('dragging');e.preventDefault();});
  window.addEventListener('mousemove',function(e){if(!down)return;moved=true;car.scrollLeft=sl-(e.pageX-sx);});
  window.addEventListener('mouseup',function(){down=false;car.classList.remove('dragging');});
  car.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
  setInterval(function(){
    if(paused||down||document.hidden) return;
    var cardEl=car.querySelector('.v9-rev'); if(!cardEl) return;
    var step=cardEl.offsetWidth+14;
    if(car.scrollLeft+car.clientWidth>=car.scrollWidth-4) car.scrollTo({left:0,behavior:'smooth'});
    else car.scrollBy({left:step,behavior:'smooth'});
  },3500);
})();

  // Physicians infinite centre-snap carousel (mobile)
  (function(){
    if(!window.matchMedia('(max-width: 900px)').matches) return;
    var track=document.querySelector('.experts-grid');
    if(!track) return;
    var cards=[].slice.call(track.children).filter(function(el){return el.querySelector && el.querySelector('.expert-photo');});
    if(cards.length<2) return;
    var setCount=cards.length;
    cards.forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');track.appendChild(k);});
    for(var i=cards.length-1;i>=0;i--){var k2=cards[i].cloneNode(true);k2.setAttribute('aria-hidden','true');track.insertBefore(k2,track.firstChild);}
    var all=[].slice.call(track.children).filter(function(el){return el.querySelector && el.querySelector('.expert-photo');});
    function centerTo(idx,smooth){
      var el=all[idx]; if(!el) return;
      var left=el.offsetLeft-(track.clientWidth-el.clientWidth)/2;
      track.scrollTo({left:left,behavior:smooth?'smooth':'auto'});
    }
    function nearestIndex(){
      var c=track.scrollLeft+track.clientWidth/2, best=0, bd=Infinity;
      all.forEach(function(el,i){var m=el.offsetLeft+el.clientWidth/2; var d=Math.abs(m-c); if(d<bd){bd=d;best=i;}});
      return best;
    }
    requestAnimationFrame(function(){centerTo(setCount,false);});
    var settle;
    track.addEventListener('scroll',function(){
      clearTimeout(settle);
      settle=setTimeout(function(){
        var i=nearestIndex();
        if(i<setCount) centerTo(i+setCount,false);
        else if(i>=setCount*2) centerTo(i-setCount,false);
      },140);
    },{passive:true});
  })();

  // Reviews v12: per-card Read more (collapses on carousel swipe) + Loox grid load-more
  (function(){
    function arm(scope, textSel, cardSel){
      document.querySelectorAll(scope+' '+textSel).forEach(function(t){
        var card=t.closest(cardSel);
        var btn=card && card.querySelector('.review-readmore');
        if(!btn) return;
        requestAnimationFrame(function(){
          if(t.scrollHeight>t.clientHeight+4){ btn.hidden=false; }
        });
        btn.addEventListener('click',function(){
          var on=card.classList.toggle('expanded');
          btn.textContent=on?'Read less':'Read more';
        });
      });
    }
    arm('#reviewGrid','.review-quote','.review-card');
    var grid=document.getElementById('reviewGrid');
    if(grid){
      var st;
      grid.addEventListener('scroll',function(){
        clearTimeout(st);
        st=setTimeout(function(){
          grid.querySelectorAll('.review-card.expanded').forEach(function(c){
            c.classList.remove('expanded');
            var b=c.querySelector('.review-readmore'); if(b) b.textContent='Read more';
          });
        },160);
      },{passive:true});
    }
    var btn=document.getElementById('reviewsListMoreBtn');
    var list=document.getElementById('reviewsList');
    if(btn&&list){
      var pool=null, idx=0;
      function starsHtml(n){var s='';for(var i=0;i<5;i++){s+='<span class="star'+(i<n?' on':'')+'">\u2605</span>';}return '<span class="star-rating" aria-label="'+n+' out of 5 stars">'+s+'</span>';}
      function escT(t){var d=document.createElement('div');d.textContent=t;return d.innerHTML;}
      function renderChunk(){
        for(var i=0;i<8&&idx<pool.length;i++,idx++){
          var r=pool[idx];
          var art=document.createElement('article');
          art.className='rl-card';
          art.innerHTML='<div class="rl-top">'+starsHtml(r.s)+'<span class="ver"><span class="ver-check" aria-hidden="true">\u2713</span></span></div>'+
            '<p class="rl-text">'+escT(r.t)+'</p>'+
            '<div class="rl-meta"><span class="who">'+escT(r.n)+'</span><time>'+escT(r.d)+'</time></div>';
          list.appendChild(art);
        }
        if(idx>=pool.length){ btn.parentElement.style.display='none'; }
      }
      btn.addEventListener('click',function(){
        if(pool){ renderChunk(); return; }
        var inline=document.getElementById('nanoxReviewsData');
        if(inline){ pool=JSON.parse(inline.textContent); renderChunk(); return; }
        fetch(btn.dataset.src).then(function(r){return r.json();}).then(function(d){ pool=d; renderChunk(); });
      });
    }
  })();

/* v: 2026-07-27 reviews-v12 push */

/* Re-arm Read more after fonts/layout settle (initial pass can run before clamp metrics are final) */
(function(){
  function rearm(){
    document.querySelectorAll('#reviewGrid .review-quote, #reviewsList .rl-text').forEach(function(t){
      var card=t.closest('.review-card')||t.closest('.rl-card');
      var btn=card&&card.querySelector('.review-readmore');
      if(btn&&btn.hidden&&t.scrollHeight>t.clientHeight+4){ btn.hidden=false; }
    });
  }
  if(document.readyState==='complete'){ rearm(); } else { window.addEventListener('load',rearm); }
  if(document.fonts&&document.fonts.ready){ document.fonts.ready.then(rearm); }
  setTimeout(rearm,1500);
})();

  // Sticky "Get Relief" CTA -> buybox
  (function(){
    var bar=document.getElementById('stickyRelief');
    var btn=document.getElementById('stickyReliefBtn');
    var buy=document.getElementById('purchase');
    if(!bar||!btn||!buy) return;
    btn.addEventListener('click',function(){ buy.scrollIntoView({behavior:'smooth',block:'start'}); });
    var ticking=false;
    function upd(){
      ticking=false;
      var r=buy.getBoundingClientRect();
      var show=r.bottom<0;
      bar.classList.toggle('show',show);
      bar.setAttribute('aria-hidden',show?'false':'true');
    }
    window.addEventListener('scroll',function(){
      if(!ticking){ ticking=true; requestAnimationFrame(upd); }
    },{passive:true});
    upd();
  })();

(function(){
  var grid=document.getElementById('reviewGrid');
  if(!grid) return;
  grid.addEventListener('touchmove',function(){
    grid.querySelectorAll('.review-card.expanded').forEach(function(c){
      c.classList.remove('expanded');
      var b=c.querySelector('.review-readmore'); if(b) b.textContent='Read more';
    });
  },{passive:true});
})();

/* ATC anchor price + save line */
(function(){
  var otp=document.querySelector('#mainAtc .otp');
  var save=document.getElementById('atcSaveLine');
  if(!otp) return;
  var busy=false;
  function base(){ var b=document.querySelector('.qty-option[data-qty="1"]'); return b?parseFloat(b.dataset.unit):49.99; }
  function qty(){ var s=document.querySelector('.qty-option.selected'); return s?parseInt(s.dataset.qty,10):3; }
  function decorate(){
    if(busy) return; busy=true;
    var m=otp.textContent.trim().match(/^\$([0-9.]+)$/);
    if(m){
      var now=parseFloat(m[1]); var q=qty(); var anchor=base()*q;
      if(save){ var d=anchor-now;
        save.innerHTML=(d>0.01?('<s>$'+anchor.toFixed(2)+'</s> You save $'+d.toFixed(2)+' \u00b7 '):'')+'\u2248 '+q+' month'+(q>1?'s':'')+' of daily use'; }
    }
    busy=false;
  }
  new MutationObserver(decorate).observe(otp,{childList:true,characterData:true,subtree:true});
  decorate();
})();
/* Delivery frequency follows pack size until the customer picks one (3-pack default = every 3 months) */
(function(){
  var pills=[].slice.call(document.querySelectorAll('.freq-pill'));
  if(!pills.length) return;
  pills.forEach(function(p){ var m=parseInt(p.dataset.months||'1',10); if(m>12){ m=Math.max(1,Math.round(m/30)); } p.dataset.months=String(m); });
  var user=false, prog=false;
  pills.forEach(function(p){ p.addEventListener('click',function(){ if(!prog) user=true; },true); });
  function applyDefault(){
    var sel=document.querySelector('.qty-option.selected');
    var want=sel&&sel.dataset.freqDefault?sel.dataset.freqDefault:'1';
    var withPlan=pills.filter(function(p){return p.dataset.planId;});
    var target=withPlan.filter(function(p){return p.dataset.months===String(want);})[0]||withPlan[0]||pills[0];
    if(target && !target.classList.contains('active')){ prog=true; target.click(); prog=false; }
  }
  document.querySelectorAll('.qty-option').forEach(function(el){ el.addEventListener('click',function(){ setTimeout(applyDefault,0); }); });
  applyDefault();
})();

/* Quantity tiles follow the selected plan: subscribing reprices every tile */
(function(){
  var tiles=[].slice.call(document.querySelectorAll('.qty-option'));
  if(!tiles.length) return;
  var base=(function(){ var b=document.querySelector('.qty-option[data-qty="1"]'); return b&&b.dataset.total?parseFloat(b.dataset.total):49.99; })();
  var disc=(function(){ var w=document.querySelector('.purchase-plans'); return w&&w.dataset.subDiscount?parseFloat(w.dataset.subDiscount)||0.8:0.8; })();
  function money(n){ return '$'+n.toFixed(2); }
  function repriceTiles(){
    var plan=document.querySelector('.purchase-plans [data-freq].selected');
    var sub=!!(plan&&plan.dataset.freq==='subscribe');
    tiles.forEach(function(t){
      var qty=parseInt(t.dataset.qty,10);
      var unit=parseFloat(t.dataset.unit);
      var shownUnit=sub?unit*disc:unit;
      var up=t.querySelector('.unit-price');
      if(up){
        var each=qty>1?' <small>/each</small>':'';
        up.innerHTML=(shownUnit<base-0.01?'<s>'+money(base)+'</s> ':'')+money(shownUnit)+each;
      }
      var badge=t.querySelector('.discount');
      var off=Math.round((1-(shownUnit/base))*100);
      if(badge){ badge.textContent=off>0?off+'% OFF':''; badge.style.display=off>0?'':'none'; }
      else if(off>0){
        var d=document.createElement('div'); d.className='discount'; d.textContent=off+'% OFF';
        t.insertBefore(d, up);
      }
    });
  }
  document.querySelectorAll('.purchase-plans [data-freq]').forEach(function(p){ p.addEventListener('click',function(){ setTimeout(repriceTiles,0); }); });
  tiles.forEach(function(t){ t.addEventListener('click',function(){ setTimeout(repriceTiles,0); }); });
  repriceTiles();
})();

/* v15 buy box (29 Sep 2026): the pack rows and the subscribe tick box drive the hidden v14 tiles and plan cards,
   so variant id, selling plan, cadence lock, price and add-to-cart all stay on the existing engine above.
   Bundles are one-time; subscribe applies to the single tube only. */
(function(){
  var wrap=document.getElementById('v15Packs');
  if(!wrap) return;
  var rows=[].slice.call(wrap.querySelectorAll('.v15-pack'));
  var box=document.getElementById('v15SubBox');
  var chk=document.getElementById('v15SubChk');
  var oneNow=document.getElementById('v15OneNow');
  var oneWas=document.getElementById('v15OneWas');
  var hasSub=!!document.querySelector('.purchase-plans [data-freq="subscribe"]');
  var wantSub=!!(chk && chk.checked);
  function tile(n){ return document.querySelector('.qty-option[data-qty="'+n+'"]'); }
  function plan(f){ return document.querySelector('.purchase-plans [data-freq="'+f+'"]'); }
  function selectedN(){ var s=document.querySelector('.qty-option.selected'); return s ? s.dataset.qty : '1'; }
  function isSub(){ var p=document.querySelector('.purchase-plans [data-freq].selected'); return !!(p && p.dataset.freq==='subscribe'); }
  function render(){
    var n=selectedN(), sub=isSub();
    rows.forEach(function(r){ var on=r.dataset.pack===n; r.classList.toggle('selected',on); r.setAttribute('aria-checked',on?'true':'false'); });
    if(box) box.classList.toggle('is-hidden', n!=='1' || !hasSub);
    if(chk) chk.checked = sub;
    if(oneNow) oneNow.textContent = sub ? oneNow.dataset.sub : oneNow.dataset.full;
    if(oneWas) oneWas.style.display = sub ? '' : 'none';
  }
  function apply(n){
    var t=tile(n);
    if(t && !t.classList.contains('selected')) t.click();
    var want=(n==='1' && wantSub && hasSub) ? 'subscribe' : 'onetime';
    var p=plan(want);
    if(p && !p.classList.contains('selected')) p.click();
    render();
  }
  rows.forEach(function(r){
    r.addEventListener('click', function(){ apply(r.dataset.pack); });
    r.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); apply(r.dataset.pack); } });
  });
  if(chk) chk.addEventListener('change', function(){ wantSub=chk.checked; apply('1'); });
  apply(selectedN());
})();
